exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.txFilters input {\n    font-family: 'Roboto Mono', monospace !important;\n    margin-bottom: 2px;\n}\n\n", ""]);
